import React, { useEffect, useState, useRef, useContext } from "react";
import AnimatedLetters from "../../AnimatedLetters";
import img from "../../../assets/images/heroImage.svg";
import { AiFillHtml5 } from "react-icons/ai";
import { FaCss3Alt } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { SiMongodb, SiTypescript, SiNextdotjs } from "react-icons/si";
import { DiNodejs, DiReact, DiMysql } from "react-icons/di";
import { FormContext } from "../../../App";
import "./index.scss";
const Hero = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const { formOpen, setFormOpen } = useContext(FormContext);
  const container = useRef(null);
  const layer = useRef(null);
  const nameArray = ["Z", "i", "y", "a"];
  const devArray = [
    "W",
    "e",
    "b",
    " ",
    "D",
    "e",
    "v",
    "e",
    "l",
    "o",
    "p",
    "e",
    "r",
  ];

  function handleMouse(e) {
    document.querySelectorAll(".layer").forEach((layer) => {
      const speed = layer.getAttribute("data-speed");
      const x = (window.innerWidth - e.pageX * speed) / 100;
      const y = (window.innerHeight - e.pageY * speed) / 100;
      layer.style.transform = `translateX(${x}px) translateY(${y}px)`;
    });
  }
  useEffect(() => {
    setTimeout(() => {
      return setLetterClass("text-animate-hover");
    }, 4000);
  }, []);

  return (
    <div className="heroSection" ref={container} onMouseMove={handleMouse}>
      <div data-speed="-5" className={"layer stackIcons"} ref={layer}>
        <AiFillHtml5 />
      </div>
      <div data-speed="6" className={"layer stackIcons"}>
        <FaCss3Alt />
      </div>
      <div data-speed="-2" className={"layer stackIcons"}>
        <IoLogoJavascript />
      </div>
      {/* <div data-speed="6" className={"layer stackIcons"} >
          <GrWordpress/>
    </div> */}
      <div data-speed="6" className={"layer stackIcons"}>
        <SiNextdotjs />
      </div>
      <div data-speed="8" className={"layer stackIcons"}>
        <SiMongodb />
      </div>
      <div data-speed="-2" className={"layer stackIcons"}>
        <DiNodejs />
      </div>
      <div data-speed="10" className={"layer stackIcons"}>
        <DiReact />
      </div>
      <div data-speed="-9" className={"layer stackIcons"}>
        <DiMysql />
      </div>

      <div data-speed="-9" className={"layer stackIcons"}>
        <SiTypescript />
      </div>
      <div className={"heroWrapper layer"} data-speed="2">
        <div className="heroText">
          <div className="topText">
            <span className={`hello ${letterClass}`}>Hello.</span>
            <br />
            <span className={`${letterClass}_12`}>I </span>
            <span className={`${letterClass}_13`}>a</span>
            <span className={`${letterClass}_14`}>m </span>

            <span className="name">
              <AnimatedLetters
                letterClass={letterClass}
                strArray={nameArray}
                idx={4}
              />
              <br />{" "}
              <span className="dev">
                <AnimatedLetters
                  letterClass={letterClass}
                  strArray={devArray}
                  idx={13}
                />
              </span>
            </span>
          </div>
          <div className="description">
            A Frontend Engineer churning pixels into perfection. I help business
            strong their online presence by developing aesthetic UI. Let's{" "}
            <span
              className="connectLine"
              onClick={() => setFormOpen(!formOpen)}
            >
              Connect
            </span>{" "}
            to build more!
          </div>
        </div>

        <div className="heroImage">
          <img src={img} alt="proud_coder" />
        </div>
      </div>
      <div className="gradient"></div>
    </div>
  );
};

export default Hero;
